import styles from "./ReportRangeSelector.module.css";

const options = [
    {
        value: "all",
        label: "همه",
    },
    {
        value: 3,
        label: "۳ ماه",
    },
    {
        value: 6,
        label: "۶ ماه",
    },
    {
        value: 12,
        label: "۱۲ ماه",
    },
];

const ReportRangeSelector = ({
    value,
    onChange,
}) => {

    return (

        <div className={styles.wrapper}>

            {options.map((item) => (

                <button
                    key={item.value}
                    type="button"
                    className={
                        value === item.value
                            ? styles.active
                            : styles.button
                    }
                    onClick={() => onChange(item.value)}
                >

                    {item.label}

                </button>

            ))}

        </div>

    );

};

export default ReportRangeSelector;
